//应用模块路由
export default [{
        path: '/application',
        name: 'application',
        component: () => import('../views/Application/index.vue'),
    }, {
        path: '/application/matters',
        name: 'matters',
        component: () => import('../views/Application/matters/index.vue'),
    }, {
        // 通用审批
        path: '/application/process/audit',
        name: 'process/audit',
        component: () => import('../views/Application/matters/baseAudit.vue'),
    }, {
        // 设计策划书审批
        path: '/application/design/auditdesignManage',
        name: 'design/auditdesignManage',
        component: () => import('../views/Application/matters/components/scoreAudit.vue'),
    }, {
        // 施组(方案)审批
        path: '/application/technical/shiGroupApprovalAudit',
        name: 'technical/shiGroupApprovalAudit',
        component: () => import('../views/Application/matters/components/shiGroupAudit.vue'),
    }, {
        // 项目风险金返还审批
        path: '/application/riskRefund/audit',
        name: 'businessAffairs/riskRefundAudit',
        component: () => import('../views/Application/matters/components/projectRiskRefundAudit.vue'),
    }, {
        // 设计需求申请审批
        path: '/application/design/demand/approve',
        name: 'design/demand/approve',
        component: () => import('../views/Application/matters/components/demandAudit.vue'),
    }, {
        // 设计策划计划表签字
        path: '/application/design/demand/sign',
        name: 'design/demand/sign',
        component: () => import('../views/Application/matters/components/signAudit.vue'),
    }, {
        path: '/application/messages',
        name: 'messages',
        component: () => import('../views/Application/messages/index.vue'),
    }, {
        path: '/application/messages/detail',
        name: 'messageDetail',
        component: () => import('../views/Application/messages/detail.vue'),
    },{
        path: '/application/myMessages',
        name: 'myMessages',
        component: () => import('../views/Application/myMessages/index.vue'),
    }, {
        path: '/application/myMessages/detail',
        name: 'myMessagesDetail',
        component: () => import('../views/Application/myMessages/detail.vue'),
    }, {
        path: '/application/approval',
        name: 'approval',
        component: () => import('../views/Application/approval.vue'),
    },
    // 查看审批详情
    {
        path: '/approve/matters/details',
        name: 'approvalDetails',
        component: () => import('../views/Application/matters/details.vue'),
    },
    // 司机日常用车考核列表
    {
        path: '/application/driverAssessment',
        name: 'driverAssessment',
        component: () => import('../views/Application/vehicleManagement/driverAssessment/index.vue'),
    },
    // 司机日常用车考核表单
    {
        path: '/application/driverAssessment/add',
        name: 'driverAssessmentFrom',
        component: () => import('../views/Application/vehicleManagement/driverAssessment/AssessmentFrom.vue'),
    },
    // 出行任务列表
    {
        path: '/application/travelTask',
        name: 'carUsePersonScore',
        component: () => import('../views/Application/vehicleManagement/travelTask'),
    },
    // 用车人评价列表
    {
        path: '/application/carUsePersonScore',
        name: 'carUsePersonScore',
        component: () => import('../views/Application/vehicleManagement/useCar/index.vue'),
    },
    // 用车人评价表单
    {
        path: '/application/carUsePersonScore/add',
        name: 'carUsePersonScoreForm',
        component: () => import('../views/Application/vehicleManagement/useCar/add.vue'),
    },
    // 用车详情
    {
        path: '/application/carUsePersonScore/carUseDetail',
        name: 'carUseDetail',
        component: () => import('../views/Application/vehicleManagement/useCar/carUseDetail.vue'),
    },
    // 用车详情
    {
        path: '/application/travelTask/travelTaskDetail',
        name: 'carUseDetail',
        component: () => import('../views/Application/vehicleManagement/travelTask/travelTaskDetail.vue'),
    },
    // // 测试录音
    // {
    //     path: '/application/travelTask/record',
    //     name: 'carUseDetail',
    //     component: () => import('../views/Application/vehicleManagement/travelTask/record.vue'),
    // },
    // 食堂用餐人数
    {
        path: '/application/canteen/dinersNum',
        name: 'dinersNum',
        component: () => import('../views/Application/canteen/dinersNum'),
    },
    // 食堂用餐表单
    {
        path: '/application/canteen/dinersNum/form',
        name: 'dinersForm',
        component: () => import('../views/Application/canteen/dinersNum/add'),
    },
    // 食堂采购
    {
        path: '/application/canteen/purchase',
        name: 'canteenPpurchase',
        component: () => import('../views/Application/canteen/purchase'),
    },
    // 食堂采购新增
    {
        path: '/application/canteen/purchase/form',
        name: 'purchaseForm',
        component: () => import('../views/Application/canteen/purchase/add'),
    },
    // 食堂日常考核
    {
        path: '/application/canteen/assessment',
        name: 'canteenAssessment',
        component: () => import('../views/Application/canteen/assessment'),
    },
    // 食堂日常考核新增详情
    {
        path: '/application/canteen/assessment/form',
        name: 'canteenAssessmentForm',
        component: () => import('../views/Application/canteen/assessment/add'),
    },
    // 用餐评价
    {
        path: '/application/canteen/evaluate',
        name: 'canteenEvaluate',
        component: () => import('../views/Application/canteen/evaluate'),
    },
    // 用餐评价新增详情
    {
        path: '/application/canteen/evaluate/form',
        name: 'canteenEvaluateForm',
        component: () => import('../views/Application/canteen/evaluate/add'),
    },
    // 出行申请
    {
        path: '/application/travelApplication',
        name: 'travelApplication',
        component: () => import('../views/Application/travelApplication'),
    },
    // 出行申请-选择出行人员
    {
        path: '/application/travelApplication/selectPeople',
        name: 'travelApplicationSelectPeople',
        component: () => import('../views/Application/travelApplication/selectPeople'),
    },
    // 出行申请-申请记录
    {
        path: '/application/travelApplication/list',
        name: 'travelApplicationList',
        component: () => import('../views/Application/travelApplication/list'),
    },
    // 出行申请-申请详情
    {
        path: '/application/travelApplication/detail',
        name: 'travelApplicationDetail',
        component: () => import('../views/Application/travelApplication/detail'),
    },
    // 出行申请-申请审批
    {
        path: '/process/VehicheAudit',
        name: 'VehicheAudit',
        component: () => import('../views/Application/matters/components/carApplyAudit'),
    },
    // 蓝牙测试
    {
        path: '/application/BlueTooth',
        name: 'BlueTooth',
        component: () => import('../components/bluetooth'),
    },
    // 人脸识别
    {
        path: '/application/FaceCamera',
        name: 'FaceCamera',
        component: () => import('../components/faceCamera'),
    },
    // 人脸识别H5
    {
        path: '/application/FaceCameraH5',
        name: 'FaceCameraH5',
        component: () => import('../components/faceCamera/index-h5.vue'),
    },
    // 审批信息
    {
        path: '/application/approvalInfo',
        name: 'approvalInfo',
        component: () => import('../views/Application/approvalInfo'),
    },
    

]